//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { AddReachProSupportCaseNoteRequest, CreateReachProSupportCaseRequest, ReachProSupportCaseNoteResponse, ReachProSupportCaseResponse } from './types';


export interface IReachProSupportCaseClient {

    getSupportCases(): Promise<ReachProSupportCaseResponse[]>;

    getSupportCaseNotes(workItemId: number | undefined): Promise<ReachProSupportCaseNoteResponse[]>;

    createSupportCase(request: CreateReachProSupportCaseRequest): Promise<ReachProSupportCaseResponse>;

    addSupportCaseNote(request: AddReachProSupportCaseNoteRequest): Promise<ReachProSupportCaseNoteResponse>;
}

export class ReachProSupportCaseClient extends PosClientBase implements IReachProSupportCaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSupportCases(signal?: AbortSignal | undefined): Promise<ReachProSupportCaseResponse[]> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/GetSupportCases";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportCases(_response);
        });
    }

    protected processGetSupportCases(response: Response): Promise<ReachProSupportCaseResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseResponse[]>(null as any);
    }

    getSupportCaseNotes(workItemId: number | undefined, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseNoteResponse[]> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/GetSupportCaseNotes?";
        if (workItemId === null)
            throw new Error("The parameter 'workItemId' cannot be null.");
        else if (workItemId !== undefined)
            url_ += "workItemId=" + encodeURIComponent("" + workItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportCaseNotes(_response);
        });
    }

    protected processGetSupportCaseNotes(response: Response): Promise<ReachProSupportCaseNoteResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseNoteResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseNoteResponse[]>(null as any);
    }

    createSupportCase(request: CreateReachProSupportCaseRequest, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseResponse> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/CreateSupportCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSupportCase(_response);
        });
    }

    protected processCreateSupportCase(response: Response): Promise<ReachProSupportCaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseResponse>(null as any);
    }

    addSupportCaseNote(request: AddReachProSupportCaseNoteRequest, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseNoteResponse> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/AddSupportCaseNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddSupportCaseNote(_response);
        });
    }

    protected processAddSupportCaseNote(response: Response): Promise<ReachProSupportCaseNoteResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseNoteResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseNoteResponse>(null as any);
    }
}
